import { render, staticRenderFns } from "./horizontalBarChart.vue?vue&type=template&id=7456f198&scoped=true&"
import script from "./horizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./horizontalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./horizontalBarChart.vue?vue&type=style&index=0&id=7456f198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7456f198",
  null
  
)

export default component.exports